export enum AirwallexEnvironment {
    DEMO = 'demo',
    PROD = 'prod',
}
